export default __webpack_public_path__ + "static/media/Wechat.34ddfbf9.svg";